export function parseJwt(token) {
  if (!token) return Error("JWT Token must be provided");
  var payload = token.split(".")[1];
  if (!payload) return Error("JWT Token must have a Payload");
  var jwt = window.atob(payload.replace("-", "+").replace("_", "/"));
  return JSON.parse(jwt);
}
